import { render } from "./TenderDetail.vue?vue&type=template&id=a4880e10"
import script from "./TenderDetail.vue?vue&type=script&lang=js"
export * from "./TenderDetail.vue?vue&type=script&lang=js"

import "./TenderDetail.vue?vue&type=style&index=0&id=a4880e10&lang=css"
import "./TenderDetail.vue?vue&type=style&index=1&id=a4880e10&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__